<template src="./Video.component.html"></template>
<style type="text/css" src="./Video.component.css"></style>

<script>
export default {
  name: "Video",
  data() {
    return {
      windowWidth: window.innerWidth,
      height: 600
    };
  },
  watch: {
    windowWidth(val, oldVal) {
      this.setWidth(val);
    }
  },
  methods: {
    open() {
      window.open(
        "https://res.cloudinary.com/drj02qnpn/image/upload/v1631428539/SKB_EP_en__brief_1_1_1_1__compressed.pdf",
        "_blank"
      );
    },
    setWidth(width) {
      if (width > 768 && width < 1024) {
        this.height = 500;
      } else if (width > 500 && width < 769) {
        this.height = 300;
      } else if (width < 500) {
        this.height = 200;
      } else {
        this.height = 600;
      }
    },
    onResize() {
      this.windowWidth = window.innerWidth;
      this.setWidth(window.innerWidth);
    }
  },
  mounted() {
    window.addEventListener("load", this.onResize);
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Video/Video.component.vue